import React, { useState } from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { useResizedMedia } from 'utils/useResizedMedia'
import { useTrackVisibility } from 'utils/useTrackVisibility'
import { LinkButton } from 'lib/Button/Button'
import { textSize, textWeight, Text } from 'lib/Text'
import { useIsBrandInList } from 'modules/member/lists/queries/useBrandLists'
import { RemindMeButton } from 'modules/thingdrops/components/RemindMeButton'
import { useCurrentBrand } from '../context/CurrentBrandProvider'

const Container = styled.article`
  border: 1px solid var(--black-15);
  margin-top: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${media.tabletDown} {
    padding: 24px;
  }
`

const ImageContainer = styled.div`
  position: relative;
  &::after {
    ${textWeight('bold')}
    ${textSize('small')}
    content: 'Promoted';
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 2px 6px;
    border-radius: 10px;
    z-index: 1;
    position: absolute;
    top: 8px;
    right: 8px;
  }
`

export const JunaThingdropAd = () => {
  const { brand } = useCurrentBrand()
  const { imgAttributes, small } = useResizedMedia({
    mediaUrl: '/assets/thingdrop/promos/juna-promo.png',
    width: 750,
    height: 420,
    imageResizeOptions: { endpoint: 'cdn' }
  })

  const skip = brand.slug !== 'seed'

  const inWttList = useIsBrandInList('539', 'WantToTest')

  const [hasInteractedWithRemindMe, setHasInteractedWithRemindMe] = useState(false)

  const { ref: visibilityRef } = useTrackVisibility<HTMLDivElement>({
    seenLong: 'Thingdrop Promotion Seen',
    skip,
    payload: {
      promotion: 'juna',
      brandId: brand.id,
      brandTitle: brand.title,
      brandSlug: brand.slug
    }
  })

  if (skip) {
    return null
  }

  return (
    <Container ref={visibilityRef}>
      <ImageContainer>
        <img
          src={small}
          srcSet={imgAttributes.srcSet}
          data-srcset={imgAttributes.dataSrcSet}
          sizes={imgAttributes.sizes}
          data-sizes={imgAttributes.dataSizes}
          alt="Juna"
        />
      </ImageContainer>
      <Text weight="medium" size="m" as="h3">
        Interested in gut health?
      </Text>
      <Text>Juna has a Thingdrop this Friday at 11am EST</Text>
      {!inWttList && hasInteractedWithRemindMe ? (
        <RemindMeButton brandId="539" brandTitle="Juna" productDropId="104" canParticipate onClick={() => setHasInteractedWithRemindMe(true)} />
      ) : (
        <LinkButton href="/thingdrop/juna-104?from=relatedBrand" color="primary">
          View Thingdrop
        </LinkButton>
      )}
    </Container>
  )
}
